import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { MdAdd, MdOutlineChatBubbleOutline } from 'react-icons/md'
// import { MdOutlineShare } from 'react-icons/md'
// import ShareProfileModal from './ShareProfileModal'
import SelectJobModal from '../../QueryPage/components/organisms/SelectJobModal'
import { addToMatches } from '../../../redux/actions'
import './ThreeDotMenu.css'

const ThreeDotMenu = ({ talent, skillListingId, conversationId }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const menuRef = useRef(null)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  // const [shareOpen, setShareOpen] = useState(false)
  const [matchesOpen,  setMatchesOpen]  = useState(false)

  useEffect(() => {
    if (!dropdownOpen) return undefined

    const handleOutsideClick = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
      document.removeEventListener('touchstart', handleOutsideClick)
    }
  }, [dropdownOpen])

  const handleClick = (key) => {
    setDropdownOpen(false)
    // if (key === 'share') setShareOpen(true)
    if (key === 'matches') setMatchesOpen(true)
    if (key === 'message' && conversationId) {
      history.push({
        pathname: `/conversations/${conversationId}`,
        state: { openConvo: true, conversationId },
      })
    }
  }

  const MENU = [
    // { key: 'share', Icon: MdOutlineShare, label: 'Share Profile' },
    { key: 'matches', Icon: MdAdd,                      label: 'Add to Matches' },
    { key: 'message', Icon: MdOutlineChatBubbleOutline, label: 'Message Talent', disabled: !conversationId },
  ]

  const handleJobSelect = (job) => {
    dispatch(addToMatches({
      GigId: job.JobOrderId,
      JobTitle: job.title,
      SkillListingId: skillListingId,
      SkillListingTitle: talent.title,
    }))
    setMatchesOpen(false)
  }

  return (
    <div className="tdm-wrapper" ref={menuRef}>
      <button className="tdm-trigger" type="button" onClick={() => setDropdownOpen((v) => !v)}>
        ⋮
      </button>

      {dropdownOpen && (
        <div className="tdm-dropdown">
          {MENU.map(({ key, Icon, label, disabled }) => (
            <button
              key={key}
              className="tdm-item"
              type="button"
              disabled={disabled}
              onClick={() => handleClick(key)}
            >
              <Icon className="tdm-item-icon" />
              {label}
            </button>
          ))}
        </div>
      )}

      {/* <ShareProfileModal
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        talent={talent}
      /> */}

      <SelectJobModal
        open={matchesOpen}
        onClose={() => setMatchesOpen(false)}
        onSelect={handleJobSelect}
      />
    </div>
  )
}

export default ThreeDotMenu
